import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

export type CardTemplateProps = {
  title: string,
  subtitle: string,
  body: any,
  actions?: any
};

export default function CardTemplate(props: CardTemplateProps) {
  return (
    <Card sx={{ maxWidth: '435px', borderRadius: '16px', padding: '32px', margin: 'none'}}>
      <CardContent sx={{ padding: '0px !important', minHeight: '24em', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
        <div>
          <Typography sx={{ marginBottom: '24px', color: '#033FFF', fontSize: '20px' , fontWeight: '600' }} gutterBottom variant="h5" component="div">
            { props.title }
            <p style={{ color: 'black', margin: '6px 0px', fontSize: '16px', fontWeight: '100' }}>{ props.subtitle }</p>
          </Typography>
          <div>{ props.body }</div>
        </div>
        <CardActions  sx={{ marginTop: '24px', padding: '0px' }}>
          { props.actions && props.actions }
        </CardActions>
      </CardContent>
    </Card>
  );
};
